<div class="resource-row">
  @if (href(); as url) {
    <a
      class="resource-row__name"
      [href]="url"
      [attr.target]="external() ? '_blank' : null"
      [attr.rel]="external() ? 'noopener noreferrer' : null"
    >
      {{ name() }}
    </a>
  } @else {
    <span class="resource-row__name resource-row__name--static">
      {{ name() }}
    </span>
  }
  <p class="resource-row__description">{{ description() }}</p>
</div>
